import { buildBase } from "./constants";

const BASE = buildBase("memberships");

export const MEMBERSHIPS_ROUTES = (() => {
  /*
    ======================================================
    ADD ALL BASIC ROUTES HERE
    ======================================================
  */
  const basicRoutes = {
    ROOT: BASE,
    LIST: BASE,
    CREATE: `${BASE}/create`,
  };

  /*
    ======================================================
    ADD ALL ROUTES THAT REQUIRE NESTING BELOW
    ======================================================
  */
  const GROUPS_ROOT = BASE;
  const GROUPS = {
    ROOT: GROUPS_ROOT,
    detail: (membershipGroupId: string | number) =>
      `${GROUPS_ROOT}/${membershipGroupId}`,
    groupMembers: (membershipGroupId: string | number) =>
      `${GROUPS_ROOT}/${membershipGroupId}/group-members`,
    groupStats: (membershipGroupId: string | number) =>
      `${GROUPS_ROOT}/${membershipGroupId}/group-stats`,
  };

  const buildLevelsRoot = (membershipGroupId: string | number) =>
    `${BASE}/${membershipGroupId}/levels`;
  const LEVELS = {
    list: (membershipGroupId: string | number) =>
      buildLevelsRoot(membershipGroupId),
    detail: (
      membershipGroupId: string | number,
      membershipLevelId: string | number
    ) => `${buildLevelsRoot(membershipGroupId)}/${membershipLevelId}`,
  };

  const UPGRADE_PATHS_ROOT = `${BASE}/upgrade-paths`;
  const UPGRADE_PATHS = {
    ROOT: UPGRADE_PATHS_ROOT,
  };

  return {
    ...basicRoutes,
    GROUPS,
    LEVELS,
    UPGRADE_PATHS,
  };
})();
